import React, { useEffect, useState, Fragment } from 'react';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const productImage = 'https://cdn.magicpatterns.com/uploads/7KHpuz45MwLcVettH6PoTv/ChatGPT-Image-14-jul-2026_-01_43_33-p.m..webp';
export function PricingCard() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 45,
    seconds: 30
  });
  useEffect(() => {
    const timer = window.setInterval(() => setTimeLeft(current => {
      if (current.seconds > 0) return {
        ...current,
        seconds: current.seconds - 1
      };
      if (current.minutes > 0) return {
        ...current,
        minutes: current.minutes - 1,
        seconds: 59
      };
      if (current.hours > 0) return {
        hours: current.hours - 1,
        minutes: 59,
        seconds: 59
      };
      return {
        hours: 1,
        minutes: 45,
        seconds: 30
      };
    }), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const units = [['STUNDEN', timeLeft.hours], ['MINUTEN', timeLeft.minutes], ['SEKUNDEN', timeLeft.seconds]];
  return <section id="pricing" className="scroll-mt-2 border-y-4 border-brand-gold/35 bg-brand-beige px-4 py-6 sm:px-6" data-id="element-107">
      <header className="mb-4 text-center" data-id="element-108">
        <p className="mb-1 text-xs font-bold tracking-wider text-brand-gold" data-id="element-109">
          SPEZIALANGEBOT — KOMPLETTES 6-IN-1 SYSTEM
        </p>
        <p className="mx-auto max-w-xl text-sm font-medium leading-relaxed" data-id="element-110">
          Hol dir noch heute sofortigen Zugriff und verändere grundlegend, wie
          du Tanzunterricht planst, aufbaust und durchführst.
        </p>
        <p className="mt-3 text-sm font-bold text-brand-burgundy" data-id="element-111">
          💃 DANCE PRO™ — Das komplette 6-in-1 Planungssystem für Tanzlehrer
        </p>
        <a href="#pricing" className="mt-3 block" data-id="element-112">
          <img src={productImage} alt="DANCE PRO™ Planungssystem" className="mx-auto w-full max-w-[265px] rounded-sm object-contain drop-shadow-xl" data-id="element-113" />
        </a>
      </header>
      <div className="rounded-lg border-4 border-brand-gold bg-brand-cream p-4 text-center shadow-xl" data-id="element-114">
        <p className="text-sm font-bold" data-id="element-115">
          Regulärer Preis: <span className="line-through" data-id="element-116">97 €</span>
        </p>
        <p className="mt-1 text-sm font-extrabold tracking-wide text-red-700" data-id="element-117">
          🔥 72% RABATT — LIMITIERTES EINFÜHRUNGSANGEBOT
        </p>
        <p className="mt-1 font-heading text-5xl font-bold leading-none text-brand-burgundy" data-id="element-118">
          Nur heute: 27 €
        </p>
        <p className="mt-2 text-xs font-bold text-brand-muted" data-id="element-119">
          Sichere Zahlung. Sofortiger Zugriff nach dem Kauf.
        </p>
        <div className="my-4 rounded-md border border-red-300 bg-red-50 p-2.5" data-id="element-120">
          <p className="mb-2 text-xs font-bold text-red-700" data-id="element-121">
            🔥 Dieser Sonderpreis gilt nur, solange der Countdown läuft.
          </p>
          <div className="flex justify-center gap-2" data-id="element-122">
            {units.map(([label, value], index) => <Fragment key={label} data-id="element-123">
                {index > 0 && <span className="pt-1 text-xl font-bold text-brand-burgundy" data-id="element-124">
                    :
                  </span>}
                <div data-id="element-125">
                  <div className="rounded bg-brand-burgundy px-2.5 py-1 text-xl font-bold leading-none text-white" data-id="element-126">
                    {String(value).padStart(2, '0')}
                  </div>
                  <p className="mt-1 text-[9px] font-bold tracking-wide text-brand-muted" data-id="element-127">
                    {label}
                  </p>
                </div>
              </Fragment>)}
          </div>
        </div>
        <CTAButton href="https://dance-master-system.impultienda.ar/checkout" data-id="element-128">
          🚀 JA! ICH WILL MEIN KOMPLETTES DANCE PRO™ SYSTEM
        </CTAButton>
        <p className="mt-3 text-[11px] font-bold text-brand-muted" data-id="element-129">
          Sofortiger Zugriff · Direkte Lieferung per E-Mail · Lebenslanger
          Zugriff
        </p>
      </div>
      <div className="mt-4 flex flex-col items-center gap-1 text-center text-[11px] font-bold sm:text-xs" data-id="element-130">
        <span className="flex items-center gap-1" data-id="element-131">
          <StarIcon className="h-4 w-4 fill-brand-gold text-brand-gold" data-id="element-132" />⭐
          4.9/5 — Bewertungen von Tanzlehrern aus Deutschland, Österreich und
          der Schweiz
        </span>
        <span className="flex items-center gap-1" data-id="element-133">
          <ShieldCheckIcon className="h-4 w-4 text-brand-burgundy" data-id="element-134" />
          🛡️ 7 Tage Geld-zurück-Garantie — Vollständig risikolos
        </span>
      </div>
    </section>;
}